import React from 'react'
import cn from 'classnames'
import { Icon, IconType } from '..'

type Props = Omit<React.HTMLAttributes<HTMLElement>, 'type'> & {
  type: IconType
  color?: string
}

const IconButton: React.FC<Props> = ({ type, color, className, ...rest }) => (
  <button className={cn('removeGenericButtonStyles p-0', className)} {...rest} aria-label='search'>
    <Icon containerClass='d-flex completeCenter w-100 h-100' type={type} color={color} />
  </button>
)

export default IconButton
